import moment from 'moment';

import {trackEvent} from 'analytics/Analytics';
import {STUDIES_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import GenerateLLMReportModal from 'studies/report-generation/GenerateLLMReportModal';
import {generateLLMReportFromEntries, generateLLMReportFromStudy} from 'studies/StudyDAO';
import {MOMENT_DATE_FORMAT} from 'ui-library/inputs/LegacyDateInput';
import runModal from 'ui-library/runModal';
import {withLoadingScreen} from 'util/Promises';

const GENERATING_REPORT_MESSAGE: string = 'Generating report...';

export async function promptAndGenerateLLMReportFromEntries(entryIds: Array<string>): Promise<string | null> {
  trackEvent(STUDIES_ANALYTICS_ACTIONS.OPENED_GENERATE_LLM_REPORT_MODAL, {source: 'entries'});
  const args = await runModal(GenerateLLMReportModal, {});
  if (args == null) {
    return null;
  }
  const {newEntryName, templateId, folderId} = args;
  // Always start reports with the current date. This is done on the frontend since the backend isn't
  // currently timezone-aware.
  const initialDay = moment().format(MOMENT_DATE_FORMAT);
  const {newEntryId} = await withLoadingScreen(
    generateLLMReportFromEntries(templateId, entryIds, folderId, newEntryName, initialDay),
    GENERATING_REPORT_MESSAGE
  );
  return newEntryId;
}

export async function promptAndGenerateLLMReportFromStudy(studyId: string): Promise<string | null> {
  trackEvent(STUDIES_ANALYTICS_ACTIONS.OPENED_GENERATE_LLM_REPORT_MODAL, {source: 'study'});
  const args = await runModal(GenerateLLMReportModal, {});
  if (args == null) {
    return null;
  }
  const {newEntryName, templateId, folderId} = args;
  // Always start reports with the current date. This is done on the frontend since the backend isn't
  // currently timezone-aware.
  const initialDay = moment().format(MOMENT_DATE_FORMAT);
  const {newEntryId} = await withLoadingScreen(
    generateLLMReportFromStudy(templateId, studyId, folderId, newEntryName, initialDay),
    GENERATING_REPORT_MESSAGE
  );
  return newEntryId;
}
